import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { DefaultUrlSerializer, Params, provideRouter, UrlSerializer, UrlTree, withComponentInputBinding, withHashLocation } from '@angular/router';
import { GlobalErrorHandlerService } from '@warranty/services';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { routes } from './app.routes';

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    const [pathAndQuery, fragment] = url.split('#', 2);
    const [path, query] = pathAndQuery.split('?', 2);
    const normalizedUrl = `${path.toLowerCase()}${query ? `?${query}` : ''}${fragment ? `#${fragment.toLowerCase()}` : ''}`;
    const urlTree = super.parse(normalizedUrl);
    urlTree.queryParams = Object.entries(urlTree.queryParams).reduce((params, [key, value]) => {
      const normalizedKey = key.toLowerCase();
      params[normalizedKey] = value;
      return params;
    }, {} as Params);
    return urlTree;
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withHashLocation(), withComponentInputBinding()),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: UrlSerializer, useClass: LowerCaseUrlSerializer },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ]
};
